import { useState } from "react";

import IconArrowDown from "../../images/icon_arrow_down.svg";
import { GroupItem, Item, UnorderedList } from "./SideMenuStyles";

function Dropdown({ children, title }) {
  const [active, updateActive] = useState(true);
  return (
    <Item active={active}>
      <GroupItem onClick={() => updateActive((active) => !active)}>
        {title}
        <img src={IconArrowDown} alt="iconDown" />
      </GroupItem>
      <UnorderedList className={!active ? "hide" : null}>
        {children}
      </UnorderedList>
    </Item>
  );
}

export default Dropdown;
